// store/slices/modalSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface ModalState {
  categoryPopupVisible: boolean;
}

const initialState: ModalState = {
  categoryPopupVisible: false
};

const modalSlice = createSlice({
  name: 'modal',
  initialState,
  reducers: {
    openCategoryPopup: (state) => {
      state.categoryPopupVisible = true;
    },
    closeCategoryPopup: (state) => {
      state.categoryPopupVisible = false;
    }
  }
});

export const { openCategoryPopup, closeCategoryPopup } = modalSlice.actions;
export default modalSlice.reducer;